import { render, staticRenderFns } from "./ganyu-edit.vue?vue&type=template&id=04fbd06b&scoped=true&"
import script from "./ganyu-edit.vue?vue&type=script&lang=ts&"
export * from "./ganyu-edit.vue?vue&type=script&lang=ts&"
import style0 from "./ganyu-edit.vue?vue&type=style&index=0&id=04fbd06b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fbd06b",
  null
  
)

export default component.exports